var exports = {
  "L": "x0a7806d5--765f02--overlay",
  "u": "x0a7806d5--765f02--spinner",
};

module.exports = exports;
